import { Fragment, useEffect, useRef, useState } from "react";
import Api from "../components/Api";
import Layout from "../components/Layout";

import { Swiper, SwiperSlide } from "swiper/react";

// Import Swiper styles
import "swiper/css";
import "swiper/css/navigation";

import SwiperCore, { Navigation, Autoplay } from "swiper";
import { Link } from "react-router-dom";
import SingleSector from "../components/SingleSector";
import { Helmet } from "react-helmet";
import { useContext } from "react";
import GlobalState from "../contexts/GlobalState";
import { Parallax } from "react-scroll-parallax";
import SingleListElement from "../components/single-list-element";
import Reports from "./Reports";
import Report from "../components/report";
import BlueArrow from "../components/icons/blue-arrow";

const Home = () => {
  SwiperCore.use([Autoplay]);

  const [show, setShow] = useState(false);
  const [images, setImages] = useState([]);

  const { generalDataGlobal } = useContext(GlobalState);

  const [generalDataApiOptions, setGeneralDataApiOptions] = useState({});
  const [homeSettings, setHomeSettings] = useState();
  const [homeSwiper, setHomeSwiper] = useState();
  const [providers, setProviders] = useState();
  const [sectors, setSectors] = useState();
  const [reports, setReports] = useState();
  const [resources, setResources] = useState();
  const [methods, setMethods] = useState();
  const [list, setList] = useState();
  const [banner, setBanner] = useState();
  const [aidList, setAidList] = useState([]);

  const [showProvider, setShowProvider] = useState(false);
  const [provider, setProvider] = useState();

  const locale = localStorage.getItem('language');

  useEffect(() => {
    if (showProvider) {
      document.querySelector("body").style.overflow = "hidden";
    } else {
      document.querySelector("body").style.overflow = "";
    }
  }, [showProvider]);

  useEffect(() => {
    window.triggerScroll();
  });

  useEffect(() => {
    if (provider) {
      document.addEventListener("keydown", function (e) {
        e = e || window.event;
        // eslint-disable-next-line
        if (e.keyCode == "27") {
          // right arrow
          setShowProvider(false);
        }
      });
    }
    // eslint-disable-next-line
  }, [provider]);

  const chooseProvider = (index) => {
    setProvider(providers[index]);
    setShowProvider(true);
  };

  useEffect(() => {
    setGeneralDataApiOptions({
      url: "home-settings",
      callback: (res) => {
        setHomeSettings(res.data.home_settings);
        setHomeSwiper(res.data.home_swiper);
        setProviders(res.data.providers);
        setSectors(res.data.sectors);
        setReports(res.data.reports);
        setResources(res.data.resources);
        setMethods(res.data.methods);
        setList(res.data.home_list);
        setBanner(res.data.home_banner);
        setAidList(res.data.aid_list);
      },
    });
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const videosRef = useRef([]); // Ref to store video elements

  const handleSlideChange = (swiper) => {
    // Stop all videos and reset them
    videosRef.current.forEach((video) => {
      if (video) {
        video.pause();
        video.currentTime = 0;
      }
    });

    // Play the video in the active slide
    const activeSlideIndex = swiper.activeIndex;
    const activeVideo = videosRef.current[activeSlideIndex];
    if (activeVideo) {
      activeVideo.play();
    }
  };

  const handleCloseLightbox = () => {
    setShow(false);
    setImages([]);
  };

  useEffect(() => {
    if (show) {
      document.querySelector("body").style.overflow = "hidden";
    } else {
      document.querySelector("body").style.overflow = "";
    }
  }, [show]);

  return (
    <>
      <Api options={generalDataApiOptions} />

      {homeSettings ? (
        <Layout>
          <Helmet>
            <title>{generalDataGlobal[0]?.seo[0].title}</title>
            <meta name="title" content={generalDataGlobal[0]?.seo[0].title} />
            <meta
              name="description"
              content={generalDataGlobal[0]?.seo[0].description}
            />

            <meta
              property="og:title"
              content={generalDataGlobal[0]?.seo[0].title}
            />
            <meta
              property="og:description"
              content={generalDataGlobal[0]?.seo[0].description}
            />
            <meta
              property="og:image"
              content={generalDataGlobal[0]?.seo[0].image_path}
            />

            <meta
              property="twitter:title"
              content={generalDataGlobal[0]?.seo[0].title}
            />
            <meta
              property="twitter:description"
              content={generalDataGlobal[0]?.seo[0].description}
            />
            <meta
              property="twitter:image"
              content={generalDataGlobal[0]?.seo[0].image_path}
            />
          </Helmet>
          {banner.length ? (
            <section
              className="home-banner-wrapper position-relative d-flex align-items-end"
              animate=""
            >
              <Swiper
                modules={[Navigation]}
                slidesPerView={1}
                // loop={true}
                onSlideChange={handleSlideChange} // Trigger on slide change
                navigation={{
                  nextEl: ".swiper-button-next-banner",
                  prevEl: ".swiper-button-prev-banner",
                }}
                className="banner-swiper h-100 w-100 position-absolute top-0 left-0"
              >
                {banner?.length
                  ? banner.map((el, index) => (
                      <SwiperSlide key={el.id}>
                        <div className="h-100 w-100 d-flex flex-column justify-content-end shadow">
                          {el.title || el.excerpt ? (
                            <div className="home-banner-overlay"></div>
                          ) : (
                            <></>
                          )}
                          <div className="position-absolute top-0 left-0 w-100 h-100">
                            {el.video ? (
                              <video
                                ref={(video) =>
                                  (videosRef.current[index] = video)
                                }
                                src={el.video_path}
                                type="video/mp4"
                                className="cover h-100 w-100"
                                autoPlay
                                muted
                                loop
                              ></video>
                            ) : (
                              <img
                                src={el.image_path}
                                className="w-100 h-100 cover"
                                alt="single element"
                              />
                            )}
                          </div>
                          <div className="home-banner-content position-relative d-flex flex-column justify-content-between">
                            <div
                              className="container position-relative"
                              style={{ zIndex: "1000" }}
                            >
                              {el?.title || el?.excerpt ? (
                                <div className="row">
                                  <div className="col-lg-7">
                                    <p className="banner-title">{el.title}</p>
                                  </div>
                                  <div className="col-lg-8 text-white banner-excerpt">
                                    <p>{el.excerpt}</p>
                                  </div>
                                  {el.link ? (
                                    <a
                                      href={el.link}
                                      target="blank"
                                      rel="noreferrer noopener "
                                    >
                                      <button className="prev-article w-auto h-auto p-3">
                                        <p className="text-white mb-0">
                                          {el.btn_label}
                                        </p>
                                      </button>
                                    </a>
                                  ) : (
                                    <></>
                                  )}
                                </div>
                              ) : (
                                <></>
                              )}
                            </div>
                          </div>
                        </div>
                      </SwiperSlide>
                    ))
                  : null}
              </Swiper>
              <div className="home-banner-content position-relative d-flex flex-column justify-content-between">
                <div
                  className="container position-relative"
                  style={{ zIndex: "3" }}
                >
                  {/* {homeSettings?.title || homeSettings?.excerpt ? (
                    <div className="row">
                      <div className="col-lg-7">
                        <p className="banner-title">{homeSettings.title}</p>
                      </div>
                      <div className="col-lg-8 text-white banner-excerpt">
                        <p>{homeSettings.excerpt}</p>
                      </div>
                      <Link to={homeSettings.banner_link}>
                        <button className="prev-article w-auto h-auto p-3">
                          <p className="text-white mb-0">
                            {homeSettings.learn_more}
                          </p>
                        </button>
                      </Link>
                    </div>
                  ) : (
                    <></>
                  )} */}
                </div>
                <div className="container">
                  <div className="row">
                    <div className="col-12">
                      <div className="d-flex justify-content-center justify-content-md-end w-100">
                        <div className="position-relative home-banner-buttons d-flex justify-content-between">
                          <div className="swiper-button-prev-banner home">
                            <button className={(locale === "en" ? "prev-article" : 'next-article') }>
                              <img
                                src="/assets/images/arrow-right-white.svg"
                                alt=""
                              />
                            </button>
                          </div>

                          <div className="swiper-button-next-banner home">
                            <button className={(locale === "en" ? "next-article" : 'prev-article')}>
                              <img
                                src="/assets/images/arrow-right-white.svg"
                                alt=""
                              />
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          ) : (
            <></>
          )}

          {homeSwiper.length ? (
            <section className="home-swiper-wrapper">
              <div className="container">
                <div className="row">
                  <div className="col-12">
                    <Swiper
                      modules={[Navigation]}
                      spaceBetween={20}
                      slidesPerView={1}
                      // loop={true}
                      navigation={{
                        nextEl: ".swiper-button-next1",
                        prevEl: ".swiper-button-prev1",
                      }}
                      breakpoints={{
                        800: {
                          slidesPerView: "2",
                        },
                        1200: {
                          slidesPerView: "3",
                        },
                      }}
                      className="home-swiper"
                    >
                      {homeSwiper?.length
                        ? homeSwiper.map((el, index) => (
                            <SwiperSlide key={el.id}>
                              <div className="swiper-element h-100 d-flex flex-column shadow">
                                <div className="mb-2">
                                  <img
                                    src={el.icon_path}
                                    alt="single element"
                                    width="48"
                                    height="48"
                                  />
                                </div>
                                <div className="swiper-title-home">
                                  <h1>{el.title}</h1>
                                </div>
                                <div className="swiper-excerpt-home d-flex flex-grow-1 mt-3">
                                  <p>{el.excerpt}</p>
                                </div>
                                {/* <div className="url-home-swiper">
                                  <a href={el.url} className="">
                                    <div className="d-flex align-items-center">
                                      <p className="view-resource me-1">
                                        {homeSettings.learn_more}
                                      </p>
                                     <BlueArrow/>
                                    </div>
                                  </a>
                                </div> */}
                              </div>
                            </SwiperSlide>
                          ))
                        : null}
                    </Swiper>
                  </div>
                  <div className="col-12">
                    <div className="d-flex justify-content-center justify-content-md-end">
                      <div className="position-relative home-swiper-buttons">
                        <div className="swiper-button-prev1 home">
                          <button className="prev-article">
                            <img
                              src="/assets/images/arrow-right-white.svg"
                              alt=""
                            />
                          </button>
                        </div>

                        <div className="swiper-button-next1 home">
                          <button className="next-article">
                            <img
                              src="/assets/images/arrow-right-white.svg"
                              alt=""
                            />
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          ) : (
            <></>
          )}

          {/* HOME PAGE DYNAMIC LISTS */}
          {list.length ? (
            <section className="home-list-wrapper">
              <div className="container">
                {list.map((single, index) => (
                  <SingleListElement single={single} index={index} />
                ))}
              </div>
            </section>
          ) : (
            <></>
          )}

          {/* METHODS SECTION */}
          {methods.length ? (
            <section className="aid-tr-wrapper">
              <div className="aid-transparency mb-5">
                <div className="home-sectors-overlay position-absolute"></div>
                <Parallax
                  className="w-100 h-100 position-absolute w-100 h-100 top-0 start-0"
                  speed={-20}
                >
                  <img
                    src={
                      process.env.REACT_APP_BASE_URL +
                      homeSettings?.methods_image
                    }
                    className="aid-tr-img"
                    alt=""
                  />
                </Parallax>
                <div className="container aid-tr-container position-relative">
                  <div className="row justify-content-center">
                    <div className="col-lg-10">
                      <p className="aid-tr-title">
                        {homeSettings?.methods_title}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="container">
                <div className="row">
                  {methods.map((method, index) => (
                    <div key={method.id} className="col-lg-6 mb-4">
                      <div className="method-wrapper h-100 d-flex flex-column">
                        <div className="method-header  gap-4 d-flex align-items-center">
                          {method.icon ? (
                            <img
                              src={method.icon_path}
                              alt="method icon"
                              className="method-icon"
                            />
                          ) : (
                            <></>
                          )}

                          <div>
                            <p className="method-title">{method.title}</p>
                            <p className="mb-0">{method.subtitle}</p>
                          </div>
                        </div>
                        <div
                          className="mt-4 method-description d-flex flex-grow-1"
                          dangerouslySetInnerHTML={{
                            __html: method.description,
                          }}
                        ></div>
                        {method.link ? (
                          <Link
                            to={method.link}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            <div className="d-flex align-items-center">
                              <p className="view-resource me-1">
                                {homeSettings?.learn_more}
                              </p>
                              <BlueArrow/>
                            </div>
                          </Link>
                        ) : (
                          <></>
                        )}
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </section>
          ) : (
            <></>
          )}

          {aidList.length ? (
            <section className="aid-tr-wrapper">
              <div className="aid-transparency">
                <div className="home-sectors-overlay position-absolute"></div>
                <Parallax
                  className="w-100 h-100 position-absolute w-100 h-100 top-0 start-0"
                  speed={-20}
                >
                  <img
                    src={homeSettings?.aid_transparency_image_path}
                    className="aid-tr-img"
                    alt=""
                  />
                </Parallax>
                <div className="container aid-tr-container position-relative">
                  <div className="row justify-content-center">
                    <div className="col-lg-10">
                      <p className="aid-tr-title">
                        {homeSettings?.aid_transparency_title}
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              <div className="container">
                {aidList.map((single, index) => (
                  <div className="row aid-tr-row mb-5" key={index}>
                    <div className="col-lg-5">
                      <p className="aid-tr-titles">{single?.title}</p>
                    </div>
                    <div className="col-lg-7">
                      <div className="aid-tr-content">
                        {single?.content.includes("%%providers%%") ? (
                          <>
                            {single.content
                              .split("%%providers%%")
                              .map((text, i) => (
                                <Fragment key={i}>
                                  {/* Render plain text without HTML tags */}
                                  <span
                                    dangerouslySetInnerHTML={{ __html: text }}
                                  />
                                  {i === 0 && (
                                    <div className="d-flex flex-wrap">
                                      {providers.map((el, j) => (
                                        <div
                                          className="provider-icon-col"
                                          key={j}
                                        >
                                          <div className="ratio ratio-1x1">
                                            <img
                                              src={`${process.env.REACT_APP_BASE_URL}${el.image}`}
                                              className="shadow"
                                              alt="provider"
                                              onClick={() => chooseProvider(j)}
                                            />
                                          </div>
                                        </div>
                                      ))}
                                    </div>
                                  )}
                                </Fragment>
                              ))}
                          </>
                        ) : (
                          <div
                            dangerouslySetInnerHTML={{
                              __html: single?.content,
                            }}
                          />
                        )}
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </section>
          ) : (
            <></>
          )}

          <section className="sectors-home overflow-hidden">
            <div className="sectors-wrapper-home position-relative d-flex justify-content-center align-items-center">
              <div className="home-sectors-overlay position-absolute"></div>
              {/* <div
                className="home-sector-image position-absolute"
                style={{
                  backgroundImage:
                    "url(" +
                    process.env.REACT_APP_BASE_URL +
                    homeSettings.image_sectors +
                    ")",
                }}
              ></div> */}
              <Parallax
                className="w-100 h-100 position-absolute w-100 h-100 top-0 start-0"
                speed={-20}
              >
                <img
                  src={
                    process.env.REACT_APP_BASE_URL + homeSettings.image_sectors
                  }
                  className="aid-tr-img"
                  alt=""
                />
              </Parallax>

              <div
                className="container sectors-container-home sectors-section d-none d-sm-block"
                animate=""
              >
                <div className="sectors-home-title front position-relative">
                  <h1>{homeSettings.title_sectors}</h1>
                </div>
                <div className="row home-sectors-row">
                  {sectors
                    ? sectors?.map((sector, index) =>
                        index < 6 ? (
                          <div className="col-xl-4 col-sm-6 sectors-col">
                            <Link to={`/${locale}/sectors/${sector.slug}`}>
                              <SingleSector
                                page={"home"}
                                key={index}
                                title={sector.title}
                                excerpt={sector.excerpt}
                                icon={sector.icon}
                              ></SingleSector>
                            </Link>
                          </div>
                        ) : null
                      )
                    : null}
                </div>
                <Link to={`/${locale}/sectors`}>
                  <div className="btn-container home d-flex justify-content-center">
                    <button className="view-btn">
                      {" "}
                      {homeSettings.learn_more_sectors}{" "}
                    </button>
                  </div>
                </Link>
              </div>

              <div className="container d-block d-sm-none">
                <div className="sectors-home-title  front position-relative">
                  <h1 className="mb-0">{homeSettings.title_sectors}</h1>
                </div>
                <Swiper
                  className="home-sectors-container py-5"
                  modules={Autoplay}
                  autoplay={{
                    delay: 2500,
                    disableOnInteraction: false,
                  }}
                  slidesPerView={1.2}
                  spaceBetween={15}
                  centeredSlides={true}
                  loop={true}
                >
                  {sectors
                    ? sectors?.map((sector, index) =>
                        index < 6 ? (
                          <SwiperSlide>
                            <Link to={`/${locale}/sectors/${sector.slug}`}>
                              <SingleSector
                                page={"home"}
                                key={index}
                                title={sector.title}
                                excerpt={sector.excerpt}
                                icon={sector.icon}
                              ></SingleSector>
                            </Link>
                          </SwiperSlide>
                        ) : null
                      )
                    : null}
                </Swiper>
                <Link to={`/${locale}/sectors`} className="sectors-link">
                  <div className="btn-container home d-flex d-sm-none justify-content-center">
                    <button className="view-btn">
                      {" "}
                      {homeSettings.learn_more_sectors}{" "}
                    </button>
                  </div>
                </Link>
              </div>
            </div>
          </section>

          <section className="home-reports">
            <div className="home-reports-wrapper">
              <div className="container">
                <div className="row justify-content-center flex-column align-items-center">
                  <div className="col position-relative d-flex justify-content-center">
                    <div className="home-reports-title">
                      <h1>{homeSettings.reports_title}</h1>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="container">
              <div className="row  d-none d-sm-flex">
                {reports?.length
                  ? reports?.map((report, index) => (
                      <Report
                        report={report}
                        index={index}
                        show={show}
                        setShow={setShow}
                        images={images}
                        setImages={setImages}
                      />
                    ))
                  : null}
              </div>
            </div>

            <div className="container swiper-reports-container">
              <div className="row swiper d-block d-sm-none">
                <Swiper
                  className="home-sectors-container pb-5"
                  slidesPerView={1.2}
                  spaceBetween={15}
                  centeredSlides={true}
                  loop={true}
                >
                  {reports
                    ? reports?.slice(0, 6).map((report, index) =>
                        index < 6 ? (
                          <SwiperSlide>
                            <Report
                              report={report}
                              index={index}
                              show={show}
                              setShow={setShow}
                              images={images}
                              setImages={setImages}
                            />
                          </SwiperSlide>
                        ) : null
                      )
                    : null}
                </Swiper>
              </div>
            </div>
            {/* <div className="view-all-reports-mobile d-bloc d-sm-none">
              <Link className="read-more" to="/reports">
                {homeSettings.reports_view_all}
              </Link>
            </div> */}
          </section>

          {showProvider ? (
            provider.description ? (
              <div className="provider-popup position-fixed h-100 w-100 top-0 start-0">
                <div className="h-100 w-100 p-3">
                  <div className="d-flex align-items-center justify-content-center h-100 p-2 p-sm-5">
                    <div className="provider-content d-flex">
                      <div className="provider-image">
                        <img
                          src={process.env.REACT_APP_BASE_URL + provider?.image}
                          alt=""
                        />
                      </div>
                      <div>
                        <h1 className="provider-popup-title">
                          {provider?.title}
                        </h1>
                        <div
                          className="provider-description"
                          dangerouslySetInnerHTML={{
                            __html: provider?.description,
                          }}
                        ></div>
                      </div>
                      
                    </div>
                  </div>
                </div>
                <div
                  className={"cancel-modal position-absolute "}
                  onClick={() => setShowProvider(false)}
                >
                  {/* eslint-disable-next-line*/}
                  <a href={null}>
                    <img src="/assets/images/close-modal.svg" alt="" />
                  </a>
                </div>
              </div>
            ) : null
          ) : null}

          <div className={`reports-lightbox ${show ? "show" : ""}`}>
            <div
              className={"cancel-modal position-absolute"}
              onClick={() => handleCloseLightbox()}
            >
              {/* eslint-disable-next-line*/}
              <a href={null}>
                <img src="/assets/images/close-modal.svg" alt="" />
              </a>
            </div>

            <div className="container">
              <div className="row position-relative d-flex align-items-center justify-content-center">
                <div className="position-absolute home-banner-buttons d-none d-lg-flex justify-content-between">
                  <div className="swiper-button-prev-report home">
                    <button className="prev-article">
                      <img src="/assets/images/arrow-right-white.svg" alt="" />
                    </button>
                  </div>

                  <div className="swiper-button-next-report home">
                    <button className="next-article">
                      <img src="/assets/images/arrow-right-white.svg" alt="" />
                    </button>
                  </div>
                </div>
                <div className="col-10 d-flex align-items-center justify-content-center">
                  <Swiper
                    modules={[Navigation]}
                    navigation={{
                      nextEl: ".swiper-button-next-report",
                      prevEl: ".swiper-button-prev-report",
                    }}
                    spaceBetween={30}
                    className="reports-swiper"
                  >
                    {images?.map((single, index) => (
                      <SwiperSlide
                        key={index}
                        className="d-flex align-items-center justify-content-center"
                      >
                        <div className="">
                          <img
                            src={single}
                            alt="swiper-img"
                            className="w-100 h-100 cover"
                          />
                        </div>
                      </SwiperSlide>
                    ))}
                  </Swiper>
                </div>
                <div className="col-12 d-flex justify-content-center d-lg-none mt-3">
                  <div className="position-absolute home-banner-buttons d-lg-none d-flex justify-content-between">
                    <div className="swiper-button-prev-report home">
                      <button className="prev-article">
                        <img
                          src="/assets/images/arrow-right-white.svg"
                          alt=""
                        />
                      </button>
                    </div>

                    <div className="swiper-button-next-report home">
                      <button className="next-article">
                        <img
                          src="/assets/images/arrow-right-white.svg"
                          alt=""
                        />
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Layout>
      ) : (
        <div className="custom-loader"></div>
      )}
    </>
  );
};

export default Home;
